import React from 'react';

export default function DetailRow(props) {
  return (
    <div className="tw-flex tw-gap-2">
      <span className={'tw-text-xs tw-font-medium tw-flex-shrink-0 ' + (props.highlight ? 'tw-text-red-600' : 'tw-text-[#999]')} style={{ width: 90 }}>{props.label}</span>
      <span className={'tw-text-xs ' + (props.highlight ? 'tw-text-red-600' : 'tw-text-[#444] dark:tw-text-[#ccc]')} style={{ wordBreak: 'break-all' }}>{props.value}</span>
    </div>
  );
}
